
import { IonButton, IonTextarea, IonIcon } from '@ionic/react';
import { trash } from 'ionicons/icons';
import React from 'react';
import Page from '../components/Page';

export default class MuleDetails extends React.Component {
  render() {
    const charName = this.props.match.params.name;
    const initialValue = localStorage.getItem('mule'+charName);
    return (
      <Page title={charName} renderButtonsRight={() => {
        return <IonButton onClick={() => {
          let chars = JSON.parse(localStorage.getItem('muleCharacters'));
          let filtered = chars.filter(c => c.name != charName);
          localStorage.setItem('muleCharacters',JSON.stringify(filtered));
          localStorage.setItem('mule'+charName,undefined);
          this.props.history.goBack();
        }}><IonIcon icon={trash}/></IonButton>
      }}>
        <div style={{padding: 13}}>
          <IonTextarea 
            style={{border: "2px dotted #777",borderRadius: 5, padding: 7}}
            placeholder="Write down this character's inventory here" autoGrow 
            onIonChange={e => {
              localStorage.setItem('mule'+charName,e.target.value)
            }}
            value={initialValue}
          />
        </div>
      </Page>
    )
  }
}